import React from 'react'
import './aboutus.css'

export default function AboutUs() {
  return (
    <div className=' d-flex '>
      <div className='AboutSection'>

        <div className='w-75 '>
          <h4 className='titleAbout  mb-3'>Our Legacy</h4>
          <h3 className='AboutHeading'>
            Sikand Standley Enterprises Pvt. Ltd. (SSEPL) builds upon
            the heritage of Sikand & Company, pioneers of India&apos;s
            automotive industry since the late 1940s. The group
            introduced international automotive brands such as
            Dodge, Chrysler, Standard, and Triumph to India, and by
            the 1970s expanded into manufacturing high-quality
            components in Faridabad.  <br /><br />
            In 1984, Sikand & Company became one of India&apos;s first
            authorized Maruti Suzuki dealers, establishing a
            reputation for service excellence. Continuing this
            tradition, SSEPL was founded in 2002 with a focused
            commitment to premium automotive care and
            maintenance solutions.
          </h3>

        </div>
      </div>

    </div>
  )
}
